import { Loadable } from '../../Loadable';

export const AsyncAddDeliveryConfigurations = Loadable(() => import('./Add'));
export const AsyncEditDeliveryConfigurations = Loadable(() => import('./Edit'));
export const AsyncListDeliveryConfigurations = Loadable(() => import('./List'));
